import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { AbsenceConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AbsenceService } from './api/absence.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class AbsenceApiModule {
    public static forRoot(configurationFactory: () => AbsenceConfiguration): ModuleWithProviders<AbsenceApiModule> {
        return {
            ngModule: AbsenceApiModule,
            providers: [ { provide: AbsenceConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: AbsenceApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('AbsenceApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
